/*


https://res.cloudinary.com/rehabpath/image/upload/{manipulations}/{imageID}


*/
export default (url) => {
  if (!url) return ''
  if (!url.includes('cloudinary')) {
    return url
  }
  const imageURL = `${url.split('/').pop().split('.')[0]}`
  return imageURL
}
